import { MDCTooltip } from '@material/tooltip'

export default {
  setup() {
    try {
      this.tooltip = new MDCTooltip(this.el)
    } catch (err) {
      // TODO: FIX ME, the tool tip is sometimes initing before the target of the tooltip is rendered in the DOM
    }
  },
  destroy() {
    this.tooltip?.destroy()
    this.tooltip = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
